import {Injectable, Pipe, PipeTransform} from '@angular/core'
import * as moment from 'moment'
moment.locale('fr')

import { Event } from '../models/event.model'
import { config } from '../config/config';

@Pipe({
  name: 'ldEventsFilter'
})
@Injectable()
export class EventsFilterPipe implements PipeTransform {

  transform (events: Event[], scope = 'all', type = 'all'): Event[] {
    if (!events) return []
    return events.filter((event) => {
      const beginMoment = event.recurring ? moment.utc(event.beginAt).year(moment().year()) : moment.utc(event.beginAt)
      const endMoment = event.recurring ? moment.utc(event.endAt).year(moment().year()) : moment.utc(event.endAt)

      const featuring = { active: false, start: null, end: null, noRange: false }
      if (event.startFeaturing && event.endFeaturing) {
        featuring.active = true
        featuring.start = event.recurring ? moment.utc(event.startFeaturing).year(moment().year()) : moment.utc(event.startFeaturing)
        featuring.end = event.recurring ? moment.utc(event.endFeaturing).year(moment().year()) : moment.utc(event.endFeaturing)
        featuring.noRange = featuring.start.isSame(featuring.end, 'day')
      }

      const noRangeEvent = beginMoment.isSame(endMoment, 'day')

      const selectOnTime = type === 'all' ||
        type === 'upcoming' && beginMoment.isSameOrAfter() && endMoment.isBefore(moment().add(config.upcomingDays, 'days')) && !noRangeEvent ||
        type === 'upcoming' && beginMoment.isAfter(moment.utc(), 'day') && endMoment.isBefore(moment().add(config.upcomingDays, 'days')) && noRangeEvent ||
        type === 'current' && beginMoment.isSameOrBefore() && endMoment.isSameOrAfter() && !noRangeEvent ||
        type === 'current' && beginMoment.isSame(moment.utc(), 'day') && noRangeEvent ||
        type === 'featured' && featuring.active && featuring.start.isSameOrBefore() && featuring.end.isSameOrAfter() && !featuring.noRange ||
        type === 'featured' && featuring.active && featuring.start.isSame(moment.utc(), 'day') && featuring.end.isSame(moment.utc(), 'day') && featuring.noRange ||
        type === 'done' && endMoment.isBefore()

      if (!selectOnTime) return false

      const selectOnType = scope === 'all' ||
        (scope === 'public' && event.groups.length === 0) ||
        (scope === 'private' && event.groups.length > 0)

      return selectOnType
    })
    .sort((a, b) => {
      const aMoment = a.recurring ? moment.utc(a.beginAt).year(moment().year()) : moment.utc(a.beginAt)
      const bMoment = b.recurring ? moment.utc(b.beginAt).year(moment().year()) : moment.utc(b.beginAt)

      if (aMoment.isBefore(bMoment)) {
        return -1
      } else if (aMoment.isAfter(bMoment)) {
        return 1
      }
      return 0
    })
  }
}



// WEBPACK FOOTER //
// ../~/angular2-template-loader!./app/pipes/events-filter.pipe.ts